module.exports = __webpack_public_path__ + "img/ria-en.f330eeca.png";